module.exports = __webpack_public_path__ + "static/img/home_h122px_h5_icon_tap.79e0d35.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_h122px_h5_icon_tap.gif
// module id = DX5r
// module chunks = 0